module.exports = {"enabled":true,"url":{"hash":"https://s3-eu-west-1.amazonaws.com/launcher.eveonline.com/resources/syncHash.json","sync":"https://s3-eu-west-1.amazonaws.com/launcher.eveonline.com/resources/sync.json","motd":"https://s3-eu-west-1.amazonaws.com/launcher.eveonline.com/resources/motd.json"},"fallback":{"background":"https://web.ccpgamescdn.com/aws/eveonline/launcher/eve-ascension.jpg","overwriteBackground":"undefined"},"timer":{"interval_seconds":15,"delay_minutes":5,"multiplier":3}}


//////////////////
// WEBPACK FOOTER
// ./src/settings/sync.json
// module id = 1132
// module chunks = 0